import { render } from "./ToggleWithIcon.vue?vue&type=template&id=a096e674"
import script from "./ToggleWithIcon.vue?vue&type=script&lang=js"
export * from "./ToggleWithIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__